const BasicTable = ({ data, headings }: { data: string[][]; headings: string[] }) => {
  return (
    <table className="BasicTable">
      <thead>
        <tr className="BasicTableHeader">
          {headings.map((heading, index) => (
            <th className="BasicTableTd" key={index}>
              {heading}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index} className="BasicTableBody">
            {item.map((itm) => {
              return (
                <td className="BasicTableTd" key={itm}>
                  {itm}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default BasicTable;
